import React, { ReactElement } from 'react';
import {
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';

export interface DialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm?: () => Promise<void>;
  title: string;
  content?: string | ReactElement | null;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
}

const Dialog: React.FC<DialogProps> = ({
  open,
  onConfirm,
  onCancel,
  title,
  content = null,
  confirmText,
  cancelText,
  isLoading = false,
}) => {
  const { t } = useTranslation();
  return (
    <MuiDialog open={open} onClose={onCancel} fullWidth maxWidth='sm'>
      <DialogTitle sx={{ px: 0, textAlign: 'center' }}>{title}</DialogTitle>
      {content && typeof content === 'string' ? (
        <DialogContent>
          <DialogContentText>{content}</DialogContentText>
        </DialogContent>
      ) : (
        content
      )}
      <DialogActions>
        <Button onClick={onCancel} color='secondary'>
          {cancelText || t('cancel')}
        </Button>
        {confirmText && onConfirm && (
          <LoadingButton
            onClick={onConfirm}
            loading={isLoading}
            color='primary'
            variant='contained'>
            {confirmText}
          </LoadingButton>
        )}
      </DialogActions>
    </MuiDialog>
  );
};

export default Dialog;
